'use client'

import { useState } from 'react'
import { useDeliveryAddress } from '@/stores/useAddressStore'

import { OrderForm } from '@/app/[locale]/(common)/order-form'
import { Alert } from '@/app/[locale]/(ui)/alert'
import { useTranslations } from 'next-intl'
import { trackOrderCompleted } from '@/lib/tracking'
import { createGuestOrder } from '@/lib/orders'
import { GuestOrder } from '@/types/orders'

const BorettslagPage = () => {
  const t = useTranslations()
  const deliveryAddress = useDeliveryAddress()
  const [hasError, setHasError] = useState(false)
  const [hasSuccess, setHasSuccess] = useState(false)

  const onSubmit = async (order: GuestOrder) => {
    if (!deliveryAddress) return
    setHasError(false)
    setHasSuccess(false)

    try {
      await createGuestOrder(order)
    } catch {
      return setHasError(true)
    }

    setHasSuccess(true)
    trackOrderCompleted({
      cart: [],
      total: { gross: 0 },
      customerType: 'housing',
      orderType: 'waste',
      origin: 'form',
    })
  }

  return (
    <div className="my-12 flex items-center justify-center sm:my-16">
      <div className="w-full max-w-screen-sm bg-gray-100 p-8 sm:rounded-2xl">
        <OrderForm key={`${hasSuccess}`} onSubmit={onSubmit} customerType="housing" />
        {hasSuccess && (
          <Alert variant="success" className="mt-4">
            {t('We_have_received_your_order')}
          </Alert>
        )}
        {hasError && (
          <Alert variant="error" className="mt-4">
            {t('Error_sending_order')}
          </Alert>
        )}
      </div>
    </div>
  )
}

export default BorettslagPage
